import { Fragment, useEffect } from "react"
import { ActionButton, Button, Modal } from "components"
import { FormSection } from "./FormSection"
import { FormProvider, useForm } from "react-hook-form"
import { useApi, useToggle } from "utils"
import toast from "react-hot-toast"
import { DataList } from "../types"
import moment from "moment" 

export function Delete({ data, refetch }: { data: DataList, refetch?: () => void }) {
  const { isActive, toggle } = useToggle(false)
  const api = useApi()

  const defaultValues = {
    transaction_date: moment(new Date(data?.transaction_date!)).format("YYYY-MM-DD"),
    file_name: data?.file_name,
    file_description: data?.file_description
  }

  const onSubmit = () => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.delete(`/import-vendor/delete-file/${data.identity_batch}`),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message
        }
      )
      .then(() => {
        toggle()
        refetch && refetch()
      })
      .catch(() => {})
      .finally(resolve)
    })
  }
  const methods = useForm({ defaultValues })

  useEffect(() => {
    if(data) {
      methods.setValue("transaction_date", moment(new Date(data?.transaction_date!)).format("YYYY-MM-DD"))
      methods.setValue("file_name", data?.file_name)
      methods.setValue("file_description", data?.file_description)
    }
    // eslint-disable-next-line
  }, [data])

  return (
    <Fragment>
      <ActionButton.Delete className="join-item" onClick={toggle} />
      {isActive && 
        <Modal isOpen title="DELETE VENDOR IMPORT" closeModal={toggle}>
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <Modal.Body>
                <h5 className="text-error">Are you sure want to delete this data?</h5>
                <FormSection disabled />
              </Modal.Body>

              <Modal.Footer className="text-end">
                <Button type="submit" color="error" loading={methods.formState.isSubmitting ? "true" : undefined}>Delete</Button>
              </Modal.Footer>
            </form>
          </FormProvider>
        </Modal>
      }
    </Fragment>
  )
}